import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBillingHistory } from "../../services/apiV2";
import { TGetBillingHistoryPayload } from "../../services/apiV2.types";

export const fetchBillingHistory = createAsyncThunk(
  "billingHistory/fetchBillingHistory",
  async (payload: TGetBillingHistoryPayload, { rejectWithValue, signal }) => {
    try {
      const res = await getBillingHistory({ ...payload, config: { signal } });
      return res.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
